/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
 
import ScrollToTop from "react-scroll-to-top";

import Navbarsection from "../views/Home/Navbarsection"  
 
import Footersection from "../views/Home/Footersection"
  
import Aboutusection
 from "../views/About/Aboutusection"
export default function About() {
  return (
<>
<div className="App">
      <ScrollToTop smooth className="bg-none pl-[15px] pr-[44px]" color="blue" />
      
<Navbarsection />
 
 <Aboutusection />
     
     
    </div>


 
 
 
<Footersection />
 
  
  
</>
  )
}
